import React, { Component } from "react"
import { connect } from "react-redux"
import Dialog from "react-toolbox/lib/dialog"
import Division from "../../components/Division"
import * as strings from "../../strings"
import Yup from "../../lib/Yup"
import { Formik, Form } from "formik"
import _ from "lodash"
import styles from "./styles.css"
import * as FormikComponents from "../../components/FormikComponents"

const DEFAULT_STATE_TRANSITION = {
  fromState: "Qualquer",
  toState: "Qualquer",
}

const STATE_TRANSITION_SCHEMA = Yup.object().shape( {
  fromState: Yup.string()
    .nullable(),
  toState: Yup.string()
    .nullable(),
} )



class StateTransitionDialog extends Component {
  props: {
    onSubmit: ( mixed ) => any,
    onCancel: ( mixed ) => any,
    visible: boolean,
    debtPhases: string[],
    states: mixed[],
  }

  submit = ( values, formik ) => {
    const { fromState, toState } = values

    this.props.onSubmit( {
      fromState: fromState === "Qualquer" ? null : fromState,
      toState: toState === "Qualquer" ? null : toState,
    } )
    formik.resetForm()
  }

  cancel = formik => () => {
    this.props.onCancel( formik.values )
    formik.resetForm()
  }

  render () {
    const states = _.chain( this.props.states )
      .filter( state =>
        ( this.props.debtPhases.includes( "Litigation" ) && state.type === 1 ) ||
        ( this.props.debtPhases.includes( "Execution" ) && state.type === 2 )
      )
      .map( state => state.name )
      .sort()
      .thru( values => ( [
        "Qualquer",
        ...values,
      ] ) )
      .reduce( ( acc, val ) => ( [
        ...acc,
        { label: val, value: val },
      ] ), [] )
      .value()

    return (
      <Formik
        initialValues={DEFAULT_STATE_TRANSITION}
        validationSchema={STATE_TRANSITION_SCHEMA}
        onSubmit={this.submit}
        enableReinitialize
      >
        { ( formik ) => (
          <Dialog
            actions={[
              { label: strings.generalStrings.cancel, onClick: this.cancel( formik ) },
              { label: strings.generalStrings.keep, onClick: formik.submitForm },
            ]}
            active={this.props.visible}
            onEscKeyDown={this.cancel( formik )}
            onOverlayClick={this.cancel( formik )}
            type="small"
          >
            <Division title={strings.expenses.expenseTypeStateTransition} />
            <Form>
              <div
                className={styles.row}
                style={{
                  justifyContent: "space-between",
                }}
              >
                <FormikComponents.Dropdown
                  label={strings.expenses.fromState}
                  name="fromState"
                  source={states}
                  auto={false}
                />
                <FormikComponents.Dropdown
                  label={strings.expenses.toState}
                  name="toState"
                  source={states}
                  auto={false}
                />
              </div>
            </Form>
          </Dialog>
        )}
      </Formik>
    )
  }
}

export default connect( ( store ) => ( {
  states: _.get( store, "suggestions.states", [] ),
} ) )( StateTransitionDialog )



// WEBPACK FOOTER //
// ./src/views/ManageExpenseTypes/StateTransitionDialog.jsx